// k3Generator.js
var K3Generator = pc.createScript('k3Generator');

// initialize code called once per entity
K3Generator.prototype.initialize = function() {
    this.seedScript = this.app.root.findByName('SEEDER').script.seeder;
    this.planetInfo = this.app.root.findByName('planetInfo');
    this.app.on('systemGenerator:reset', this.setK3, this);
    this.app.on('solarSystem:allPlanets', this.setText, this);
    this.randomize = null;
    this.theText = ['THERE IS A KIII CIVILIZATION LIVING AROUND THIS SINGULARITY. THEY DON´T COMMUNICATE.',
                    'A KIII CIVILIZATION USES THIS BLACK HOLE AS THEIR HABITAT. COMMUNICATION ATTEMPTS HAVE LONG BEEN GIVEN UP.',
                    'NOBODY HAS EVER MADE CONTACT WITH THIS KIII CIVILIZATION. THEY STAY ON THEIR OWN.',
                    'KIII CIVILIZATIONS USUALLY ACT HOSTILE AT BEST ON ATEMPTED CONTACT.',
                    'THE LAST KNOWN COMMUNICATION WITH THIS KIII CIVILIZATION WAS ROUGHLY 5000 YEARS AGO.'
                   ];
};

K3Generator.prototype.setK3 = function() {
    
    if(!this.entity.parent.enabled){
        return;
    }
    
    this.theSeed = this.seedScript.seed;
    this.randomize = new Math.seedrandom(this.seedScript.getUniqueRandom());

    
    if(this.randomize() > 0.5){
        
        this.entity.enabled = true;
        
        for(var i = 0; i < 5; i++){
            this.entity.children[i].enabled = true;
            var x = this.randomize()*360;
            var y = this.randomize()*360;
            var z = this.randomize()*360;
            var all = new pc.Vec3(x,y,z);
            this.entity.children[i].setLocalEulerAngles(all);
        }
        
    } else {

        this.entity.enabled = false;
    }
    
};


K3Generator.prototype.setText = function() {
   
    if(!this.entity.enabled){
        return;
    }
    var that = this;
    //console.log('SETTEXT');
    //console.info(this.theText[Math.floor(this.randomize()*this.theText.length)]);
    setTimeout(function(){
        that.planetInfo.element.text = that.theText[Math.floor(that.randomize()*that.theText.length)];
    }, 25);
};

// update code called every frame
K3Generator.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// K3Generator.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// https://developer.playcanvas.com/en/user-manual/scripting/

